import ActionMenu from 'components/widgets/RenderLibraryTable/components/ActionMenu/ActionMenu';
import React from 'react';
import { ActionMenuItemWithIcon } from 'components/common/ActionMenuItemWithIcon/actionMenuItemWithIcon';
import { ActionButtonMenu } from 'components/widgets/RenderLibraryTable/components/ActionMenu/components/ActionButtonMenu/ActionButtonMenu';
import { useHistory } from 'react-router-dom';
import { projectConfig } from 'components/Dashboards/Project/ProjectWrapper/projectConfig';
import { LoaderSpinner } from 'components/common/LodaerSpinner/LoaderSpinner';
import { useCopyVersionStore } from 'store/copyVersion.store';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

export const ActionMenuOk = ({
    versionHashCode,
    status,
    errorMessage,
    index,
    setShowModal,
    onDownLoad,
    isLoading,
    isFileDownload,
    isAllowedToCopyVersion,
    id,
    setShowRenameVersionModal,
}) => {
    const { update } = useCopyVersionStore();
    const history = useHistory();
    const integratedProgramDetailsLink = AppRoutes.buildPathWithQuery(
        [
            AppRoutes.DASHBOARD_PROJECT_PATH,
            projectConfig.programLibrary.link,
            projectConfig.integratedProgramDetails.link,
        ],
        { metaDataId: id },
    );

    return (
        <>
            <ActionMenu
                versionIdList={versionHashCode}
                status={status}
                errorMessage={errorMessage}
                id={`viewAnalytics_${index}`}
            />
            {isLoading ? (
                <LoaderSpinner />
            ) : (
                <ActionButtonMenu id={`threeDots_${index}`} tooltipContent={'More Actions'}>
                    <ActionMenuItemWithIcon
                        handleClick={() => history.push(integratedProgramDetailsLink)}
                        iconText={'Details'}
                        iconType={'info-icon'}
                        iconSize={'1.6rem'}
                    />
                    {isFileDownload && (
                        <ActionMenuItemWithIcon
                            handleClick={onDownLoad}
                            iconText={'Download File'}
                            iconType={'Download-icon'}
                            iconSize={'1.6rem'}
                        />
                    )}

                    <ActionMenuItemWithIcon
                        handleClick={() => setShowRenameVersionModal(true)}
                        iconText={'Rename Version'}
                        iconType={'edit-user-profile'}
                        iconSize={'1.6rem'}
                    />

                    {isAllowedToCopyVersion && (
                        <ActionMenuItemWithIcon
                            handleClick={() => {
                                update({ versionId: id, versionHashCode: versionHashCode, showModal: true });
                            }}
                            useMuiIcon={true}
                            iconText={'Copy Version'}
                            iconType={'content_copy'}
                            iconSize={'1.6rem'}
                        />
                    )}

                    <ActionMenuItemWithIcon
                        handleClick={() => setShowModal(true)}
                        iconText={'Delete'}
                        iconType={'delete-icon'}
                        iconSize={'1.6rem'}
                    />
                </ActionButtonMenu>
            )}
        </>
    );
};
